declare module "react-native-bottom-alert";
